module.exports = __webpack_public_path__ + "static/img/memory7.1be42d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memory7.jpg
// module id = eTi0
// module chunks = 1